import { SUBCLUSTERS } from '../subclusters.js';

const NGO_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.EVENT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.FUNDRAISING_CRM,
        },
        {
            key: SUBCLUSTERS.GRANTS_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.VOLUNTEERS_REGISTRATION,
        },
        {
            key: SUBCLUSTERS.EMERGENCY_RESPONSE,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.BUSINESS_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.CLIENT_PROJECTS,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
        {
            key: SUBCLUSTERS.SOFTWARE_DEVELOPMENT,
        },
    ],
    mini_site: {
        logo: {
            alt: 'monday.com for non-profit',
            url: '/nonprofits',
            src: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/ngo/nonprofit_logo_56h.png',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/ngo/nonprofits_logo_mobile52h.png',
            useDesktopLogoInMobile: 'true',
        },
        links: [
            {
                url: '/nonprofits',
                text: 'minisite.header.overview',
                removeFromUnified: 'true',
            },
            {
                url: '/nonprofits/eligibility',
                text: 'minisite.header.eligibility',
            },
            {
                url: '/nonprofits/features',
                text: 'minisite.header.features',
            },
            {
                url: '/nonprofits/successhub',
                text: 'Resource Center',
            },
            {
                url: '/nonprofits/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
            {
                url: '/nonprofits/success-stories/',
                text: 'minisite.header.successStories',
            },
        ],
        unifiedDesktopLogo: {
            url: '/nonprofits',
            src: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/ngo/monday_nonprofit_logo_unify.png',
            alt: 'monday.com for non-profit',
        },
    },
    payments_view: {
        pricing: {
            discount: {
                value: '0.7',
                valid_tiers: ['pro'],
                valid_periods: ['yearly'],
                hide_crossed_out_discount: 'true',
            },
            sections: [
                {
                    section: 'COLLABORATION',
                },
                {
                    section: 'PRODUCTIVITY',
                },
                {
                    section: 'VIEWS_AND_REPORTING',
                },
                {
                    section: 'SUPPORT_NEW',
                },
                {
                    section: 'SECURITY_AND_PRIVACY',
                },
                {
                    section: 'ADMINISTRATION_AND_CONTROL',
                },
                {
                    section: 'ADVANCED_REPORTING',
                },
            ],
            value_features: {
                pro: [
                    'PRIVATE_BOARDS',
                    'CHART_VIEW',
                    'TIME_TRACKING',
                    'FORMULA',
                    'DEPENDENCY',
                    'ENTERPRISE_SCALE_AUTOMATIONS',
                    'ENTERPRISE_DASHBOARDS',
                ],
                enterprise: [
                    'ENTERPRISE_GRADE_SECURITY',
                    'ADVANCED_REPORTING',
                    'MULTI_LEVEL_PERMISSIONS',
                    'TAILORED_ONBOARDING',
                    'PREMIUM_SUPPORT',
                ],
            },
            contact_us_threshold: '100',
            plans: {
                hidden_plans: ['free', 'basic', 'standard'],
                plan_overrides: {
                    pro: {
                        displayName: 'pricingPage.plans.npo.title',
                    },
                },
            },
            tier_descriptions: {
                pro: 'pricingPage.tierDescriptions.npo.pro',
                enterprise: 'pricingPage.tierDescriptions.npo.enterprise',
            },
            most_popular: {
                forced_tier: 'pro',
                minimum_users_count: '11',
                text_for_forced_tier: 'pricingPage.plans.npo.discount',
            },
            periods: {
                hidden_periods: ['monthly'],
                display: {
                    price_display: 'yearly',
                },
            },
            users_count_options: {
                all_options: ['10', '13', '15', '20', '25', '30', '40', '50', '100', '200+'],
                free_options: ['3', '5', '10'],
            },
        },
    },
};

export { NGO_CLUSTER };
